import React from "react";
import { defineMessages } from "react-intl";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { MemoizedDefaultChip } from "../../../components/chip/ChipRenderer.js";
import { ChipType, ChipVariant } from "../../../components/chip/types.js";
import "../../../components/chip/Chips.js";
import "../../../components/chip/ListWithChipTooltip.js";
import "../../../components/chip/SquaredChipList.js";
import { Icon, IconColor } from "../../../components/icons/Icon.js";
import { CustomIcon } from "../../../components/icons/types.js";
import "../../../components/icons/ExpandMoreIcon.js";
import { LocalizedText } from "../../../components/i18n/LocalizedText.js";
import { KeyValueCell } from "../../../components/key-value-table/KeyValueCell.js";
import { KeyValueTable } from "../../../components/key-value-table/KeyValueTable.js";
import { KeyValueColumn } from "../../../components/key-value-table/KeyValueColumn.js";
import "../../../components/key-value-table/cells/CurrencyWithDateCell.js";
const localized = defineMessages({
  errors: {
    id: "bulkStepValidationSummary_errors",
    defaultMessage: "Errors"
  }
});
const useStyles = makeStyles()((theme) => ({
  resultContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    marginTop: theme.spacing(2)
  },
  resultTitle: {
    display: "flex",
    alignItems: "center",
    columnGap: theme.spacing(1.5)
  },
  resultSubtitle: {
    marginTop: theme.spacing(1)
  },
  resultIcon: {
    fontSize: "1.5em"
  },
  resultChip: {
    display: "flex",
    columnGap: theme.spacing(0.75),
    rowGap: theme.spacing(1.25),
    flexWrap: "wrap"
  }
}));
function BulkStepValidationSummarySuccess({ title, count }) {
  const { classes } = useStyles();
  return /* @__PURE__ */ React.createElement(Box, { className: classes.resultContainer }, /* @__PURE__ */ React.createElement(Box, { className: classes.resultTitle }, /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, /* @__PURE__ */ React.createElement(LocalizedText, { label: title }))), /* @__PURE__ */ React.createElement(Box, { className: classes.resultChip }, /* @__PURE__ */ React.createElement(MemoizedDefaultChip, { variant: ChipVariant.GreyInverted, type: ChipType.Status, value: `${count}` })));
}
function BulkStepValidationSummaryFailed({ subtitle, count }) {
  const { classes } = useStyles();
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Box, { className: classes.resultContainer }, /* @__PURE__ */ React.createElement(Box, { className: classes.resultTitle }, /* @__PURE__ */ React.createElement(Icon, { color: IconColor.Bronze, icon: CustomIcon.ErrorCircle, className: classes.resultIcon }), /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, /* @__PURE__ */ React.createElement(LocalizedText, { label: localized.errors }))), /* @__PURE__ */ React.createElement(Box, { className: classes.resultChip }, /* @__PURE__ */ React.createElement(MemoizedDefaultChip, { variant: ChipVariant.BronzeInverted, type: ChipType.Status, value: `${count}` }))), /* @__PURE__ */ React.createElement(Typography, { variant: "body1", color: "secondary", className: classes.resultSubtitle }, /* @__PURE__ */ React.createElement(LocalizedText, { label: subtitle })));
}
function BulkStepValidationTotalSummary({ items }) {
  return /* @__PURE__ */ React.createElement(KeyValueTable, { mode: "card" }, /* @__PURE__ */ React.createElement(KeyValueColumn, null, items?.map((i) => /* @__PURE__ */ React.createElement(
    KeyValueCell,
    {
      key: i.label.id,
      mode: "card",
      isUnderlined: false,
      titleVariant: "body1",
      title: /* @__PURE__ */ React.createElement(LocalizedText, { label: i.label })
    },
    i.value
  ))));
}
export {
  BulkStepValidationSummaryFailed,
  BulkStepValidationSummarySuccess,
  BulkStepValidationTotalSummary
};
//# sourceMappingURL=BulkStepValidationSummary.js.map
